import { Navigate, Route, Routes } from 'react-router-dom';
import { userAllowedRoutes } from './allRoutes';
import '../src/assets/scss/app.scss';
import '../src/assets/scss/bootstrap.scss';
import '../src/assets/scss/icons.scss';
import '../src/assets/scss/preloader.scss';
import '../src/assets/scss/theme.scss';
import Login from 'Login/Login';
import { isLoggedIn } from 'utils/auth/authUtils';
import Logout from 'Login/Logout';
import env from 'environment/env';
import * as Sentry from "@sentry/react";

function App() {
  return (
    <div>
      <Routes>
        <Route path={"/login"} element={<Login />} key={'login'} />
        <Route path={"/logout"} element={<Logout />} key={'logout'} />
        <Route path={"/"} element={<Navigate to="/login" />} key={'login-default'} />
        {userAllowedRoutes && userAllowedRoutes.map((route, idx) => {
          if (route.component) {
            return (
              <Route
                path={route.path}
                element={isLoggedIn() ? route.component : <Navigate to={env.desktop_app === true ? "/#login" : "/login"} />}
                key={idx}
              />
            );
          }
          return null;
        })}
      </Routes>
    </div>
  );
}

export default Sentry.withProfiler(App);
